module.exports = __webpack_public_path__ + "img/news_2.d4cc553d.png";